export const tariffsConfig = {
  demoTariffId: 52,
  specialTariffId: 61,
  yearTariffId: 62
};

export const tariffsThemes = {
  [tariffsConfig.specialTariffId]: ''
};
